import React from "react";
import { ShieldCheck, UserRound, BadgeCheck } from "lucide-react";
import { trustBadges } from "../mock";

const icons = { ShieldCheck, UserRound, BadgeCheck };

const TrustBadges = () => {
  return (
    <section className="py-20 bg-[#f3f7fc]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center reveal">
          <span className="eyebrow text-[#e07c24]">Training &amp; Trust</span>
          <h2 className="font-display font-bold text-[#0e2a63] text-[30px] sm:text-[42px] mt-4">
            Why Families Trust Us
          </h2>
        </div>
        <div className="grid md:grid-cols-3 gap-7 mt-14">
          {trustBadges.map((b, i) => {
            const Icon = icons[b.icon] || ShieldCheck;
            return (
              <div
                key={b.title}
                className={`reveal reveal-delay-${i + 1} bg-white rounded-2xl p-8 shadow-lg border border-slate-100 hover:-translate-y-2 transition-transform text-center`}
              >
                <div
                  className="w-16 h-16 rounded-2xl mx-auto flex items-center justify-center text-white mb-5"
                  style={{ background: i === 1 ? "var(--navy)" : "var(--orange)" }}
                >
                  <Icon size={30} />
                </div>
                <h3 className="font-display font-bold text-[#0e2a63] text-xl">{b.title}</h3>
                <p className="text-slate-600 mt-3 text-[15px] leading-relaxed">{b.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
